module.exports = __webpack_public_path__ + "static/media/no-image.7dc6ad22.png";